var jade = require("/web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (view) {
buf.push("<div class=\"modal-body\"><div class=\"modal-body-content\">");
if ( view.signupState.get('ssoUsed'))
{
buf.push("<h4><span data-i18n=\"signup.account_exists\"></span></h4><div class=\"small\"><b><span>" + (jade.escape(null == (jade_interp = view.signupState.get('email')) ? "" : jade_interp)) + "</span></b></div><div class=\"hr-text\"><hr><span data-i18n=\"common.next\"></span></div><button class=\"login-link btn btn-lg btn-navy\"><span data-i18n=\"login.log_in\"></span></button>");
}
buf.push("</div><div class=\"history-nav-buttons\"><button type=\"button\" class=\"back-button btn btn-lg btn-navy-alt\"><span data-i18n=\"common.back\"></span></button></div></div>");}.call(this,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/create-account-modal/single-sign-on-already-exists-view.jade
// module id = 833
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91